export const getActionsStatuses = (t) => ({
  LOCATION_ADDED: (locationName) => t('digital-signage:statuses.locationAdded', { locationName }),
  LOCATION_DELETED: (locationName) =>
    t('digital-signage:statuses.locationDeleted', { locationName }),
  LOCATION_ADDED_ERROR: t('digital-signage:statuses.locationAddedError'),
  LOCATION_DELETE_ERROR: t('digital-signage:statuses.locationDeleteError'),
  TV_APP_LINK_COPIED: t('digital-signage:statuses.tvAppLinkCopied'),
})
